import script from "./messageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageView.vue?vue&type=script&setup=true&lang=ts"

import "./messageView.vue?vue&type=style&index=0&id=5aa22082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa22082"]])

export default __exports__